export default {"src":"/_next/static/media/icon_play_events_v2.62f02594.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};